import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { bp, borderRadiusSmall } from '../globalStyles'
import Card from './Card'
import getImageUrl from '../utils/getImageUrl'

const GridWrap = styled.div`
  display: block;

  @media (${bp.desktop}) {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    flex-wrap: wrap;
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }
`
export const FeatureCard = styled(Card)`
  @media (${bp.desktop}) {
    box-shadow: none;
    margin: 0.75rem 0.75rem;
    width: calc(50% - 2rem);
    min-height: 20rem;
    max-height: 30rem;
    height: 30vw;
    align-items: flex-end;
    border-radius: ${borderRadiusSmall};
  }
`

const FeatureGrid = props => {
  function renderCards () {
    const count = props.count || 100
    const featured = props[props.type].slice(0, count)
    return featured.map(item => {
      return (
        <FeatureCard
          key={item.sys.id}
          title={item.fields.title}
          subtitle=''
          image={getImageUrl(item.fields.mainImage, 0.5)}
          to={`/${props.type}/${item.fields.slug}`}
        />
      )
    })
  }

  return <GridWrap>{renderCards()}</GridWrap>
}

FeatureGrid.propTypes = {
  type: PropTypes.string.isRequired,
  count: PropTypes.number
}

export default FeatureGrid



// WEBPACK FOOTER //
// ./src/components/FeatureGrid.js